var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.16665 1.66666V4.99999M13.8333 1.66666V4.99999M10.5 12.5H13.8333M3.83331 9.16666H17.1666M7.16665 12.5H7.24998M5.49998 16.6667H15.5C16.4205 16.6667 17.1666 15.9205 17.1666 15V4.99999C17.1666 4.07952 16.4205 3.33332 15.5 3.33332H5.49998C4.57951 3.33332 3.83331 4.07952 3.83331 4.99999V15C3.83331 15.9205 4.57951 16.6667 5.49998 16.6667Z",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.ee85fcc6ea8518d43a78493d47d69a8b.svg";
export { ForwardRef as ReactComponent };